import Vue from 'vue';
import Vuex from 'Vuex';

import MenuModal from './menu-modal' 
import MaterialModal from './material-modal' 
import LoadingIcon from './loading-icon'
import DebugModal from './debug-modal'


Vue.use(Vuex);

const state = {
}

const modules = {
  menu: MenuModal,
  material: MaterialModal,
  loading: LoadingIcon,
  debug: DebugModal,
}


const mutations = {
 
}

const actions = {

}

const store = new Vuex.Store({
  state,
  modules,
  mutations,
  actions
})

export default store;
